import { type SetComplexImmerStateAction, type UserWithId } from '@/lib/types';
import { createContext } from 'react';

const UsersContext = createContext<
  [boolean, UserWithId[], SetComplexImmerStateAction<UserWithId[]>]
>([true, [], () => {}]);

export default UsersContext;
